import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Ph4se from './pages/ph4se';
import Error from './Error';
import { PortfolioRouting } from './routing/portfolio';
import './styles/index.css';

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <Error />,
    element: <Ph4se />,
  },
  ...PortfolioRouting,
]);

const App = () => (
  <RouterProvider router={router} />
);

export default App;
